/* eslint-disable */

/** select columns of table "argo.vw_event_type_udf_column" */
export enum ArgoVwEventTypeUdfColumnSelectColumn {
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UdfColumnId = 'udf_column_id'
}

